import React, { useEffect, useRef, useState } from 'react';

import './ComunicacionHistorico.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAddComunicacion, fetchPersonaGetComunicacionList } from '../../reducers/comunicacionSlice';
import { ComunicacionColumnList, ComunicacionValidationSchema } from './ComunicacionConstants';
import { useTranslation } from 'react-i18next';
import GenericForm from '../../components/GenericForm';
import GenericAccordion from '../../components/GenericAccordion';
import GenericTimeline from '../../components/GenericTimeline';
import { fetchGetComunicacion_detalleByComunicacion, returnFetchAddComunicacion_detalle } from '../../reducers/comunicacion_detalleSlice';
import { getTimeDetail, toSqlDate } from '../../components/utils';
import { usePubSub } from '../../components/hooks/PubSubContext';

function ComunicacionHistorico(props) {

    const { t } = useTranslation();
    const formRef = useRef();
    const dispatch = useDispatch();
    const { publish } = usePubSub();

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    const [comunicacionesList, setComunicacionesList] = useState([]);
    const [showNewComunicacion, setShowNewComunicacion] = useState(false);
    const [expandedTab, setExpandedTab] = useState({});

    const columnList = ComunicacionColumnList(logguedUserData.isAdmin);

    const personaField = columnList.find(cl => cl.id === 'comunicacion_persona_id');
    personaField.form = false;

    useEffect(() => {
        initData();
    }, []);

    const initData = async () => {
        const comunicaciones = await fetchPersonaGetComunicacionList(
            {
                filters: { rowsPerPage: 10, order: 'fecha_creacion desc', persona_id: logguedUserData.persona_id }
            });

        setComunicacionesList(comunicaciones.comunicacionList);
    }

    const handleExpand = async (ev, id, force) => {
        if (force || expandedTab[id] === undefined) {
            const comunicacionDetalle = await fetchGetComunicacion_detalleByComunicacion({
                filters: {
                    comunicacion_id: id,
                    rowsPerPage: 10,
                    order: 'fecha_creacion desc'
                }
            });
            console.log('respose pr', comunicacionDetalle?.comunicacion_detalleList, logguedUserData.persona_id);

            setExpandedTab({ ...expandedTab, [id]: comunicacionDetalle?.comunicacion_detalleList?.map(cd => { return { title: toSqlDate(cd.fecha_creacion), small: getTimeDetail(cd.fecha_creacion), body: cd.mensaje, pos: cd.persona_id === logguedUserData.persona_id ? 'right' : 'left' } }) });
        }
    }

    const handleAddMessage = async (id) => {
        const mensaje = document.getElementById('new-communication-message').value;
        document.getElementById('new-communication-message').value = '';
        const respuesta = returnFetchAddComunicacion_detalle({
            comunicacion_id: id,
            mensaje,
            persona_id: logguedUserData.id
        });
        publish('closeFullModal', null);
        handleExpand(null, id, true);
    }

    const renderComunicacion = cl => {
        return (
            <GenericAccordion id={cl.id} onExpand={(ev) => { handleExpand(ev, cl.id) }} >
                <div className="aspect-content">
                    <div className="aspect-info">
                        <span className="aspect-name">{cl.titulo}</span>
                    </div>
                    <div className="aspect-stat">
                        <div className="all-opinions">
                            <span>{cl.tipo_estadodesc}</span>
                            <span className='fecha'>{cl.fecha_creacion} {getTimeDetail(cl.fecha_creacion)}</span>
                        </div>
                        <div>
                            {/*                             <span className="positive-count">4</span>
                            <span className="neutral-count">1</span>
                            <span className="negative-count">13</span> */}
                        </div>
                    </div>
                </div>
                <div>
                    <GenericTimeline
                        isExpanded={expandedTab[cl.id] !== undefined}
                        data={expandedTab[cl.id]}
                    />
                    {
                        cl.estado_final !== 1 &&
                        <div className='comunicacion-btn'>
                            <div className='button' onClick={() => {
                                publish('openFullModal', {
                                    buttons: [
                                        { label: 'Cancelar', onclick: () => { publish('closeFullModal', null) } },
                                        { label: 'Enviar', onclick: () => { handleAddMessage(cl.id) }, positive: true }
                                    ],
                                    contents: [{ content: <div><textarea id='new-communication-message'></textarea> </div> }]
                                });
                            }}>
                                Nuevo mensaje
                            </div>
                        </div>
                    }
                </div>

            </GenericAccordion>
        )
    }

    const handleShowAddComunication = () => {
        setShowNewComunicacion(true);
        window.$(`#comunicacion_modal_form`).modal('show');
    }

    const handleAddComunicacion = (values) => {
        console.log('sadf', values);
        dispatch(fetchAddComunicacion(values));
        window.$(`#comunicacion_modal_form`).modal('hide');
    }

    return (
        <div className='container-xxl flex-grow-1 container-p-y comunicacion-historico-container'>
            <div className="card full">
                <h5 className="card-header personal-module-title">Comunicación con la administación</h5>
                <div className="buy-now">
                    <div
                        onClick={handleShowAddComunication}
                        className="btn btn-buy-now"
                    >+</div>
                </div>
                {
                    comunicacionesList?.length === 0 &&
                    <div>
                        No hay ninguna comunicación
                    </div>
                }

                {
                    comunicacionesList.map(cl => renderComunicacion(cl))
                }


            </div>
            <GenericForm
                dataRef={formRef}
                title={'comunicacion'}
                formOpen={showNewComunicacion}
                onClose={() => { window.$(`#comunicacion_modal_form`).modal('hide'); }}
                columnList={columnList}
                onSubmitForm={handleAddComunicacion}
                selectedData={{ conjunto_id: logguedUserData.selConjunto?.id, creador_persona_id: logguedUserData.id }}
                validationSchema={ComunicacionValidationSchema(t)}
            />

        </div>
    );
}

export default ComunicacionHistorico;